/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import jquery from 'jquery/src/jquery'
window.jQuery = jquery
window.jquery = jquery
window.$ = jquery

import 'lity'
import '@src/common/utilities'
// Global javascript
import '@src/common/ab_tasty_generic_triggers'
import '@src/common/analytics'
import '@src/common/anchor_scroll_fix'
import '@src/common/animation'
import '@src/common/cookie'
import '@src/common/lazy_load'
import '@src/common/sentry'
import '@src/components/actions'
import '@src/components/banner'
import '@src/components/lottie-containers'
import '@src/components/tooltips'
import '@src/components/parralax'
import '@src/components/langSwitchModal'
import '@src/layouts/footer'
import '@src/layouts/header'
import '@src/polyfills/for_each'
import '@src/common/close_nav_on_click'

// AB tasty customs migrated in app
import '@src/ab_tasty_customs/blog/application'
import '@src/ab_tasty_customs/catch-traffic-en/application'
import '@src/ab_tasty_customs/creation/application'
import '@src/ab_tasty_customs/open-an-account/application'
import '@src/ab_tasty_customs/pricing/quotation/application'
import '@src/ab_tasty_customs/pricing/overlay'
import '@src/ab_tasty_customs/shared/replace_faq'
import '@src/ab_tasty_customs/shared/replace_header_with_image'
import '@src/ab_tasty_customs/team/payroll-automation/application'
import '@src/ab_tasty_customs/pricing/base'

// Javascript related to sections
import '@sections/loading_trigger'
import '@sections/manifest'
